import { useCallback } from 'react';

/**
 * Hook for Messages component business logic
 * Handles location filter changes and other Messages-specific logic
 * 
 * @param {Function} onLocationFilterChange - Callback function to handle location filter changes
 * @returns {Object} Object containing handler functions
 */
export const useMessagesHook = ({ onLocationFilterChange }) => {
  /**
   * Handles location change from FeedsLocationPicker
   * Extracts locationId from locationData and calls parent callback
   * 
   * @param {Object} locationData - Location data object from FeedsLocationPicker
   * @param {number|null} locationData.locationId - The location ID
   */
  const handleLocationChange = useCallback(
    (locationData) => {
      const locationId = locationData?.locationId || null;
      if (onLocationFilterChange) {
        onLocationFilterChange(locationId);
      }
    },
    [onLocationFilterChange]
  );

  return {
    handleLocationChange,
  };
};
